import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "../../../../../config/axios";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Form, Formik } from "formik";
import FormInputText from "../../../../../components/Forms/FormInputText";
import moment from "moment";
import { useTranslation } from "react-i18next";
import GeneralFormError from "../../../../../components/Forms/GeneralFormError";

const CheckoutGuestDialog = ({ guest, handleSubmit, handleClose }) => {
  function submit(data, { setSubmitting, setStatus, setErrors }) {
    setSubmitting(true);
    axios
      .post(`/api/v1/guests/${guest.id}/checkout.json`, {
        guest: {
          checkout_at: data.checkout_at,
        },
      })
      .then(function (response) {
        handleSubmit(response.data);
      })
      .catch(function (e) {
        if (e?.response?.data) {
          setErrors(e.response.data);
        }

        setSubmitting(false);
      });
  }

  const formRef = useRef();
  const { t } = useTranslation("dashboard");

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            {t("booking_details.checkout_guest_dialog.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            innerRef={formRef}
            initialValues={{
              ...guest,
              checkin_at: moment(guest.checkin_at).format(
                moment.HTML5_FMT.DATETIME_LOCAL
              ),
              checkout_at: moment().format(moment.HTML5_FMT.DATETIME_LOCAL),
            }}
            onSubmit={submit}
          >
            {({ values, errors }) => (
              <Form>
                <GeneralFormError errors={errors} />
                <p>{t("booking_details.checkout_guest_dialog.paragraph1")}</p>

                <FormInputText
                  name="checkin_at"
                  label={t(
                    "booking_details.checkout_guest_dialog.chekin.label"
                  )}
                  type="datetime-local"
                  disabled={true}
                />
                <FormInputText
                  name="checkout_at"
                  label={t(
                    "booking_details.checkout_guest_dialog.checkout.label"
                  )}
                  min={guest.checkin_at}
                  type="datetime-local"
                />
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Schließen
          </Button>
          <Button onClick={() => formRef?.current?.handleSubmit()}>
            Speichern
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CheckoutGuestDialog;
